<template>
  <div></div>
</template>

<script>
import moment from "moment";
import { functions } from "../assets/js/firebase";
import { formatMessage } from "../assets/js/common";
export default {
  methods: {
    async init() {
      const vm = this;
      let { id } = vm.$route.params;
      try {
        vm.$loader.show();
        let { data } = await functions.httpsCallable("getCustomer")({ id });
        vm.$loader.hide();
        if (data.data == null) {
          vm.$alert.show("Job not found");
        } else {
          let { status } = data.data;
          if (status != 7) {
            vm.$alert.show("Job is not completed yet");
          } else {
            vm.print(data.data);
          }
        }
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    print(item) {
      let { template_name, created_at, name, job_number } = item;
      let date = moment(created_at);
      let contract_date = date.format("MM/DD/YYYY");
      let contract_time = date.format("hh:mm a");
      let { html } = require("../assets/print/contract.js");
      html = html.split("template_name").join(template_name);
      html = html.split("customer_name").join(name);
      html = html.split("{job_number}").join(job_number);
      html = html.split("contract_date").join(contract_date);
      html = html.split("contract_time").join(contract_time);
      item.fields.Job_Number = job_number;
      let msg = formatMessage(item);
      html = html.split("contract_message").join(msg);
      let win = window.open("", "_self");
      win.document.write(html);
      // win.document.close();
      setTimeout(() => {
        win.print();
      }, 1000);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
